import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils';
import { TDiiaGetStatusResponse, TDiiaInitializeResponse } from '~/store/diia/types.ts';
import type { RootState } from '~/store/store.ts';

export const covenantsDiiaSignInitialize = createAsyncThunk<
  TDiiaInitializeResponse,
  { contragentId: number; applicationId: string; documentId: string },
  { state: RootState }
>('covenants/diiaSignInitialize', async ({ contragentId, applicationId }, { rejectWithValue }) => {
  try {
    const path = `/covenants-api/covenants/contragents/${contragentId}/applications/${applicationId}/diia-sign-initialize`;
    const { data } = await api.post(path, null);
    return data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const covenantsDiiaSignGetStatus = createAsyncThunk<
  TDiiaGetStatusResponse,
  { contragentId: number; applicationId: string; requestId: string },
  { state: RootState }
>(
  'covenants/diiaSignGetStatus',
  async ({ contragentId, applicationId, requestId }, { rejectWithValue, signal }) => {
    try {
      const path = `/covenants-api/covenants/contragents/${contragentId}/applications/${applicationId}/diia-sign-get-status/${requestId}`;
      const { data } = await api.post(path, null, { signal });
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const covenantsDiiaSignGetFinalStatus = createAsyncThunk<
  TDiiaGetStatusResponse,
  { contragentId: number; applicationId: string; requestId: string },
  { state: RootState }
>(
  'covenants/diiaSignGetFinalStatus',
  async ({ contragentId, applicationId, requestId }, { rejectWithValue }) => {
    try {
      const path = `/covenants-api/covenants/contragents/${contragentId}/applications/${applicationId}/diia-sign-get-final-status/${requestId}`;
      const { data } = await api.post(path, null);
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
